import React from 'react';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';
import { useKioskPro } from 'src/hooks/use-kiosk-pro';

import { Header } from 'src/dispensary/core-menu/components/header';
import { KioskProLayout } from 'src/components/kiosk-pro/kiosk-pro-layout';
import CoreMenuFooter from 'dispensary/core-menu/components/core-menu-footer';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useUI from 'src/hooks/use-ui';
import { useIsFirstRender } from 'hooks/use-is-first-render';
import { WhoopsContent, WhoopsReason } from 'src/components/whoops';

import { LayoutWrapper } from './layout-wrapper';

type CoreMenuLayoutProps = {
  children: React.ReactNode;
};

export const CoreMenuLayout = observer(({ children }: CoreMenuLayoutProps): JSX.Element | null => {
  const isFirstRender = useIsFirstRender();
  const { dispensary, loading, error } = useDispensary();
  const router = useRouter();
  const isKioskProEnabled = useKioskPro();
  const { onCollectionsPage, isKiosk } = useUI();

  const hideCategories =
    isKioskProEnabled || !(router.route.includes('products') || router.route.includes('brands') || onCollectionsPage);
  const hideFooter = isKioskProEnabled && isKiosk;

  if (isFirstRender) {
    return null;
  }

  if (isKioskProEnabled && isKiosk && dispensary) {
    return (
      <KioskProLayout dispensary={dispensary} hideCategories={hideCategories} hideFooter={hideFooter}>
        {children}
      </KioskProLayout>
    );
  }

  if (error) {
    console.error('Error fetching dispensary', error);
  }

  if (!loading && !dispensary && !error) {
    console.error('Dispensary not found', error);
    return <WhoopsContent reason={WhoopsReason.pageNotFound} />;
  }

  return (
    <LayoutWrapper>
      <Header dispensary={dispensary} />

      {children}

      <CoreMenuFooter hideCategories={hideCategories} />
    </LayoutWrapper>
  );
});
